module.exports = __webpack_public_path__ + "65e66ae6ddf930b93e69a2f236b4bd88.pdf";